<template>
    <div class='file-upload'>
        <div class='file-upload-box'>
            <el-upload
                action='http://localhost:8081/#/fileManager'
                ref='file-upload'
                :on-change='handleChange'
                :http-request='handleFileUpload'
                :on-preview='handlePreview'
                :on-exceed='handleExceed'
                :on-remove='handleRemove'
                :before-remove='handleBeforeRemove'
                :before-upload='handleBeforeUpload'
                :file-list='fileList'
                :show-file-list='showFileList'
                v-if='triggerType === "drag"'
                :list-type='listType'
                :multiple='multiple'
                :drag='triggerType === "drag"'
                :limit='limit'
                :auto-upload='autoUpload'>
                <template v-if='customTrigger' >
                    <slot name='trigger'></slot>
                </template>
                <div v-if='!customTrigger' class='trigger-file-box'>
                    <div v-if='triggerType === "drag"'>
                        <i class='el-icon-upload'></i>
                        <div class='el-upload__text'>将文件拖到此处，或<em>点击上传</em></div>
                        <div v-if='showTip' slot='tip'>{{ tip }}</div>
                    </div>
                    <el-button v-if='triggerType === "button"' slot='trigger' size='mini' type='primary'>选取文件</el-button>
                    <span v-if='triggerType === "text"' slot='trigger'>选取文件</span>
                </div>
                <div class='tip-box'>
                    <div v-if='showTip' slot='tip'>{{ tip }}</div>
                </div>
            </el-upload>
            <el-upload
                action='http://localhost:8081/#/fileManager'
                ref='file-upload'
                :on-change='handleChange'
                :http-request='handleFileUpload'
                :on-preview='handlePreview'
                :on-exceed='handleExceed'
                :on-remove='handleRemove'
                :before-remove='handleBeforeRemove'
                :before-upload='handleBeforeUpload'
                :file-list='fileList'
                :show-file-list='showFileList'
                :accept='accept'
                :list-type='listType'
                :multiple='multiple'
                v-if='triggerType !== "drag"'
                :limit='limit'
                :auto-upload='autoUpload'>
                <template v-if='customTrigger' >
                    <slot name='trigger'></slot>
                </template>
                <div v-if='!customTrigger' class='trigger-file-box'>
                    <div v-if='triggerType === "drag"'>
                        <i class='el-icon-upload'></i>
                        <div class='el-upload__text'>将文件拖到此处，或<em>点击上传</em></div>
                        <div v-if='showTip' slot='tip'>{{ tip }}</div>
                    </div>
                    <el-button v-if='triggerType === "button"' slot='trigger' size='mini' type='primary'>选取文件</el-button>
                    <span v-if='triggerType === "text"' slot='trigger'>选取文件</span>
                </div>
                <div class='tip-box'>
                    <div v-if='showTip' slot='tip'>{{ tip }}</div>
                </div>
            </el-upload>
            <el-dialog  v-if='showFilePreview' class='file-view' :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
            
            <!--<div v-if='showFileList'>-->
            <!--    <div v-for='(value, key) in uploadProgressMap'>-->
            <!--        <span>{{value[0]}}</span>:<el-progress :percentage='value[1].uploadPercentage' :format='format'></el-progress>-->
            <!--    </div>-->
            <!--</div>-->
        </div>
        <div class='file-submit-box' v-if='!controlUploadBehavior'>
            <el-button type="primary" :disabled='uploadDisable' @click='handleClickUpload' v-if='!autoUpload' size='mini'>上传</el-button>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { FileUtils } from '@/utils/file';
import { fileWebApi } from '@/components/api/File/fileWeb';
import { deepCopy } from '@/utils/object';

export default defineComponent({
    name: 'CottonFileUpload',
    data() {
        return {
            // 上传的文件列表
            fileList: [],
            dialogVisible: false,
            dialogImageUrl: undefined,
            uploadDisable: false,
            uploadData: {},
            fileListMap: new Map,
            uploadProgressMap: new Map,
            pre: {
                total: 0,
                currentUpdatedCount: 0,
                uploadPercentage: 0
            }
        };
    },
    props: {
        multiple: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        data: Object,
        showFileList: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        accept: {
            type: String,
            default: function() {
                return '*';
            }
        },
        // 文件列表的类型 text/picture/picture-card
        listType: {
            type: String,
            default: function() {
                return 'picture';
            }
        },
        // 自动上传
        autoUpload: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 最大允许上传个数
        limit: {
            type: Number,
            default: function() {
                return 10;
            }
        },
        // 提示文本
        tip: {
            type: String,
            default: function() {
                return '';
            }
        },
        showTip: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 单文件最大是多少，单位kb
        maxFileSize: {
            type: Number,
            default: function() {
                return 1024 * 1024 * 30;
            }
        },
        // 触发文件选择框的类型 支持drag,button,text
        triggerType: {
            type: String,
            default: function() {
                return 'drag';
            }
        },
        showFilePreview: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        controlUploadBehavior: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        customTrigger: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        customUploadFunction: {
            type: Function,
            required: false
        },
        customUploadOperationStatus: {
            type: Boolean,
            required: false,
            default: () => {
                return false;
            }
        },
        useChunkUpload: {
            type: Boolean,
            required: false,
            default: () => {
                return false;
            }
        }
        
    },
    emits: ['fileUploadSuccess', 'removeFile'],
    created() {
        this.uploadData = this.data
    },
    mounted() {
        this.uploadData = this.data
    },
    methods: {
        /**
         * 文件上传成功
         */
        handleUploadSuccess(response, file, fileList) {
            console.log("文件上传成功");
            console.log(response);
            console.log(file);
            console.log("---------------");
            message.success("文件上传成功")
            this.uploadDisable = false;
            this.fileListMap.get(file.uid).status = 'success'
            this.fileListMap.get(file.uid).url = response.url
            this.$emit('fileUploadSuccess', response)
        },
        /**
         * 文件上传失败
         * @param err
         * @param file
         * @param fileList
         */
        handleUploadFail(err, file, fileList) {
            this.uploadDisable = false;
            message.error(`文件上传失败 ${err.message}`)
            this.fileListMap.get(file.uid).status = 'fail'
            setTimeout(() => {
                this.fileListMap.get(file.uid).status = 'ready'
            }, 1000)
        },
        /**
         * 文件上传时
         * @param event
         * @param file
         * @param fileList
         */
        handleUploadProgress(event, file, fileList) {
            console.log(event);
        },
        
        /**
         * 文件改变，添加文件，上传成功，上传失败都会调用
         * @param file
         * @param fileList
         */
        handleChange(file, fileList) {
            this.fileList.push(file)
            this.fileListMap.set(file.uid, file)
        },
        handleRemove(file, fileList) {
            console.log("asdf");
            this.$emit('removeFile', file)
            this.fileListMap.delete(file.uid)
            this.fileList.forEach((fileTemp, index) => {
                if (fileTemp.uid === file.uid) {
                    this.fileList.splice(index, 1)
                }
            })
        },
        handleBeforeRemove(file, fileList) {
            return true
        },
        handleBeforeUpload(file) {
            let fileSize = file.size;
            if (fileSize > this.maxFileSize) {
                message.warning(`超出文件大小范围，能上传的最大文件大小为 ${FileUtils.computeFileSize(this.maxFileSize)}`);
                return false;
            }
            this.fileListMap.get(file.uid).status = 'uploading'
        },
        /**
         * 文件上传行为
         */
        handleFileUpload(file) {
            // 将没有上传的文件上传
            this.uploadDisable = true
            if (!this.data) {
                message.warning("请设置参数")
                this.uploadDisable = false
                return
            }
            
            message.warning(`文件上传中...`)
            let fileInfoData = deepCopy(this.data)
            fileInfoData.uploadFile = file.file
            fileInfoData.filePrimaryKey = file.file.uid
            
            if (this.customUploadOperationStatus) {
                this.customUploadFunction(fileInfoData);
            } else {
                if (this.useChunkUpload) {
                    fileInfoData.uploadFile = undefined
                    FileUtils.chunkUpload(file.file, fileInfoData, 1024 * 1024 * 1.25, fileWebApi.chunkCheckAndMerge,
                        fileWebApi.chunkUpload, this.updateUploadProgress, 5,
                        this.handleUploadSuccess, this.handleUploadFail)
                }else {
                    fileWebApi.singleUpload(fileInfoData).then(result => {
                        if (result.code === 200) {
                            this.handleUploadSuccess(result.data, file.file, null);
                        } else {
                            this.handleUploadFail(result, file.file, null);
                        }
                    });
                }
            }
        },
        handleExceed(files, fileList) {
            message.warning(`当前限制只能上传 ${files.length} 个文件`);
        },
        handleClickUpload() {
            this.$refs['file-upload'].submit();
        },
        handlePreview(file) {
            if (file.raw.type.startsWith("image")) {
                file.percentage = 75.3
                this.dialogVisible = true
                this.dialogImageUrl = file.url
            }
        },
        initFileList() {
            this.fileList = []
        },
        format(percentage) {
            return `${percentage.toFixed(2)}%`;
        },
        updateUploadProgress(uid, percentage) {
            let originFileData = this.fileListMap.get(uid)
            console.log(`${uid} --> ${percentage}`);
            originFileData.percentage = percentage
        }
        
    }
});
</script>

<style scoped lang='css'>
.file-upload-box {
    //display: inline-block;
}
.file-submit-box {
    height: 100%;
    margin-left: 1rem;
}
.file-upload {
    display: flex;
    height: 100%;
}

.file-view {

}
</style>
